import React, { useEffect, useState, useContext } from "react";
import {
  MdElectricCar,
  MdSyncAlt,
  MdTv,
  MdAutoAwesome,
} from "react-icons/md";
import { ReactComponent as Mhero2DesignIcon } from "../../../../assets/icons/mheroicon.svg";
import { LanguageContext } from "../../../../context/LanguageContext";
import { getPageContent } from "../../../../api/publicContent.api";
import "./Mhero2Extras.css";

const CARD_ICONS = [
  MdElectricCar,
  MdSyncAlt,
  MdTv,
  Mhero2DesignIcon,
];

const Mhero2Extras = () => {
  const { currentLang } = useContext(LanguageContext);

  const [extras, setExtras] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadExtras = async () => {
      try {
        setLoading(true);
        const response = await getPageContent("mhero2", currentLang);
        setExtras(response.sections?.extras || null);
      } catch (err) {
        console.error("Failed to load MHERO2 extras", err);
      } finally {
        setLoading(false);
      }
    };

    loadExtras();
  }, [currentLang]);

  if (loading || !extras) return null;

  const cards = [1, 2, 3, 4]
    .map((n) => ({
      title: extras[`feature_${n}_title`],
      description: extras[`feature_${n}_description`],
    }))
    .filter((card) => card.title || card.description);

  return (
    <section className="mhero2extras">
      <div className="m2-container">
        <div className="m2-header">
          {extras.title ? <h2 className="m2-title">{extras.title}</h2> : null}
          {extras.subtitle ? (
            <p className="m2-subtitle">{extras.subtitle}</p>
          ) : null}
        </div>

        <div className="m2-grid">
          {cards.map((card, index) => {
            const Icon = CARD_ICONS[index];
            const isSvgIcon = Icon === Mhero2DesignIcon;

            return (
              <div key={index} className="m2-card">
                {isSvgIcon ? (
                  <Icon className="m2-icon svg-m2-icon" />
                ) : (
                  <Icon className="m2-icon" />
                )}
                {card.title ? <h3>{card.title}</h3> : null}
                {card.description ? <p>{card.description}</p> : null}
              </div>
            );
          })}
        </div>

        {extras.positioning_line ? (
          <div className="m2-positioning">
            <MdAutoAwesome className="m2-position-icon" />
            <span>{extras.positioning_line}</span>
          </div>
        ) : null}
      </div>
    </section>
  );
};

export default Mhero2Extras;
